import { useCheckin } from './CheckinContext'
import LinhaEditavelCard from './LinhaEditavelCard'

const TerapiasCard = ({ preencherAltura }) => {
  const { listaTerapias, updateTerapia } = useCheckin()

  return (
    <LinhaEditavelCard
      titulo="Terapias Adicionais"
      lista={listaTerapias}
      onUpdateItem={updateTerapia}
      comSolicitado
      preencherAltura={preencherAltura}
      mostrarPaciente
      compactarSimboloMoeda
    />
  )
}

export default TerapiasCard
